module.exports = __webpack_public_path__ + "static/downloable/guia-solicitud-de-alta-baja-de-beneficiario-para-essalud.7f45d72.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/downloable/guias/guia-solicitud-de-alta-baja-de-beneficiario-para-essalud.pdf
// module id = gUiM
// module chunks = 1